/*
 * The shared tooltip surface every tooltip inherits through the theme Tooltip
 * defaults. Mantine's stock tooltip keeps a dark surface in light mode but flips to a
 * LIGHT surface in dark mode; the studio's two-line labels (a white title over a
 * dimmed detail — the map controls and the wizard reset tooltips) are authored for a
 * dark bubble, so the dark-mode flip rendered the white title white-on-light and
 * unreadable. Pinning the background to the near-black gray-9 and the text to white in
 * BOTH schemes keeps light mode exactly as before and stops the flip, so the white
 * title + dimmed detail read on every surface. The arrow consumes --tooltip-bg too, so
 * it follows. Theme-level classNames only resolve under the real buildTheme, so a bare
 * MantineProvider in a test keeps Mantine's stock tooltip.
 *
 * It also carries the one wrap cap every tooltip shares. The theme turns `multiline` on
 * by default, which flips Mantine's stock nowrap bubble to wrapping; the cap has to live
 * beside it or a long reason would wrap only at the viewport edge. It is a MAX-width in
 * CSS rather than the `w` prop the call sites used to pass, because `w` sets a fixed
 * width: it would stretch a one-word label ("Locked") to the full column and, being
 * per-call-site, it drifted into four different bubbles (220/240/260/300px) for the same
 * kind of hint. A max-width lets a short label shrink to fit its own text while a long
 * one wraps at the same column everywhere.
 */
.tooltip {
  --tooltip-bg: var(--mantine-color-gray-9);
  --tooltip-color: var(--mantine-color-white);

  max-width: 260px;
}
